var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-ons-toolbar',[_c('div',{staticClass:"left"},[_c('v-ons-toolbar-button',{on:{"click":function($event){return _vm.$store.commit('splitter/toggle')}}},[_c('v-ons-icon',{attrs:{"icon":"ion-ios-menu, material:md-menu"}})],1)],1),_c('div',{staticClass:"center"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }